import { render, staticRenderFns } from "./order_chart.vue?vue&type=template&id=5546884f&scoped=true&"
import script from "./order_chart.vue?vue&type=script&lang=js&"
export * from "./order_chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5546884f",
  null
  
)

export default component.exports